/**
 * La pieza del carrusel para el telefono, dentro del formulario del banner
 * (ADM-05). Es opcional: sin ella, el telefono muestra la pieza de escritorio
 * entera sobre un fondo difuminado, que funciona pero se ve chica.
 *
 * Solo dibuja. El estado (la pieza subida, si se pidio quitarla) vive en
 * `FormularioBanner`, que es quien arma el DTO.
 */
import type { ImagenBanner } from '@bandu/compartido';

import type { SubidaImagen } from '../../hooks/use-subida-imagen';
import { Icono } from '../comunes/Icono';
import { SubidorImagen } from './SubidorImagen';

export interface CampoPiezaMovilProps {
  /** La que se va a guardar: la recien subida, la que ya tenia, o ninguna. */
  pieza: ImagenBanner | null;
  subida: SubidaImagen;
  onArchivo(archivo: File): void;
  onQuitar(): void;
}

export function CampoPiezaMovil({ pieza, subida, onArchivo, onQuitar }: CampoPiezaMovilProps) {
  return (
    <div className="campo">
      <span className="campo-et">La pieza para celular (opcional)</span>

      {pieza !== null ? (
        <div className="banner-previa banner-previa-movil">
          <img src={pieza.url} alt="" width={pieza.ancho} height={pieza.alto} />
        </div>
      ) : null}

      {subida.falla !== null ? (
        <p className="acceso-error" role="alert">
          <Icono nombre="alerta" />
          <span>{subida.falla}</span>
        </p>
      ) : null}

      <SubidorImagen
        etiqueta={pieza === null ? 'elige un archivo' : 'reemplazala por otra'}
        subiendo={subida.subiendo}
        onArchivo={onArchivo}
      />

      {pieza !== null ? (
        <button
          type="button"
          className="btn btn-contorno btn-sm"
          onClick={onQuitar}
          disabled={subida.subiendo}
        >
          Quitar la pieza para celular
        </button>
      ) : null}

      <p className="campo-ayuda" role="status">
        {pieza !== null
          ? `Mide ${String(pieza.ancho)} x ${String(pieza.alto)} px.`
          : 'En el celular el carrusel es mas alto: una pieza de 8:5, por ejemplo 1200 x 750, se ve completa. Sin ella se muestra la de escritorio, mas chica.'}
      </p>
    </div>
  );
}
